"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorCode = void 0;
exports.ErrorCode = {
    AUTH_INVALID_INIT_DATA: 'AUTH_INVALID_INIT_DATA',
    AUTH_EXPIRED_INIT_DATA: 'AUTH_EXPIRED_INIT_DATA',
    AUTH_UNAUTHORIZED: 'AUTH_UNAUTHORIZED',
    USER_BLOCKED: 'USER_BLOCKED',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    RATE_LIMITED: 'RATE_LIMITED',
    NOT_FOUND: 'NOT_FOUND',
    INTERNAL: 'INTERNAL',
    EMAIL_INVALID: 'EMAIL_INVALID',
    EMAIL_TAKEN: 'EMAIL_TAKEN',
    TERMS_NOT_ACCEPTED: 'TERMS_NOT_ACCEPTED',
    CODE_INVALID: 'CODE_INVALID',
    CODE_EXPIRED: 'CODE_EXPIRED',
    CODE_NOT_REQUESTED: 'CODE_NOT_REQUESTED',
    TOO_MANY_ATTEMPTS: 'TOO_MANY_ATTEMPTS',
    RESEND_COOLDOWN: 'RESEND_COOLDOWN',
    ONBOARDING_ALREADY_ACTIVE: 'ONBOARDING_ALREADY_ACTIVE',
    /** Invited registration is on and the email is not in the list (or its entry is used by someone else). */
    REGISTRATION_NOT_INVITED: 'REGISTRATION_NOT_INVITED',
    PROVISIONING_FAILED: 'PROVISIONING_FAILED',
    PROVISIONING_RETRY_COOLDOWN: 'PROVISIONING_RETRY_COOLDOWN',
    PROVISIONING_NOT_FAILED: 'PROVISIONING_NOT_FAILED',
    WALLET_NOT_READY: 'WALLET_NOT_READY',
    WEBHOOK_FORBIDDEN: 'WEBHOOK_FORBIDDEN',
    ADMIN_INVALID_CREDENTIALS: 'ADMIN_INVALID_CREDENTIALS',
    ADMIN_ACCOUNT_LOCKED: 'ADMIN_ACCOUNT_LOCKED',
    ADMIN_ACCOUNT_DISABLED: 'ADMIN_ACCOUNT_DISABLED',
    ADMIN_PASSWORD_CHANGE_REQUIRED: 'ADMIN_PASSWORD_CHANGE_REQUIRED',
    ADMIN_PASSWORD_WEAK: 'ADMIN_PASSWORD_WEAK',
    ADMIN_STAFF_EMAIL_TAKEN: 'ADMIN_STAFF_EMAIL_TAKEN',
    ADMIN_CANNOT_DISABLE_SELF: 'ADMIN_CANNOT_DISABLE_SELF',
    /** The route needs the `admin` role (spec 2026-10-28 staff roles §5.1). */
    ADMIN_FORBIDDEN: 'ADMIN_FORBIDDEN',
    /** The record is outside the `support` member's scope: no active ticket, not a failed operation. */
    ADMIN_SCOPE_DENIED: 'ADMIN_SCOPE_DENIED',
    /** An admin cannot change their own role. */
    ADMIN_CANNOT_DEMOTE_SELF: 'ADMIN_CANNOT_DEMOTE_SELF',
    USER_ALREADY_BLOCKED: 'USER_ALREADY_BLOCKED',
    USER_NOT_BLOCKED: 'USER_NOT_BLOCKED',
    /** A Telegram transfer window can be opened only for an active user (spec 2026-10-27 §4). */
    USER_NOT_ACTIVE: 'USER_NOT_ACTIVE',
    /** No open transfer window: cancel without one, or the code arrived after the window closed. */
    TRANSFER_NOT_OPEN: 'TRANSFER_NOT_OPEN',
    SETTING_UNKNOWN: 'SETTING_UNKNOWN',
    SETTING_INVALID: 'SETTING_INVALID',
    /** The user has a PIN and the token was minted at login (not yet verified); carries nothing else. */
    PIN_REQUIRED: 'PIN_REQUIRED',
    /** Wrong PIN; carries `attemptsLeft: number`. */
    PIN_INVALID: 'PIN_INVALID',
    /** Too many wrong PINs; carries `retryAfterSeconds: number`. */
    PIN_LOCKED: 'PIN_LOCKED',
    PIN_ALREADY_SET: 'PIN_ALREADY_SET',
    PIN_NOT_SET: 'PIN_NOT_SET',
    /** Carries `issues: AllowlistImportIssue[]`; nothing was written. */
    ALLOWLIST_IMPORT_INVALID: 'ALLOWLIST_IMPORT_INVALID',
    /** Resend refused: the allowlist entry is already claimed by a user. */
    ALLOWLIST_ENTRY_USED: 'ALLOWLIST_ENTRY_USED',
    WITHDRAWALS_DISABLED: 'WITHDRAWALS_DISABLED',
    WITHDRAWAL_ASSET_DISABLED: 'WITHDRAWAL_ASSET_DISABLED',
    WITHDRAWAL_QUOTA_EXCEEDED: 'WITHDRAWAL_QUOTA_EXCEEDED',
    WITHDRAWAL_ADDRESS_INVALID: 'WITHDRAWAL_ADDRESS_INVALID',
    /** The destination is one of the user's own addresses on that chain; Fluxson would refuse it with 400 anyway. */
    WITHDRAWAL_ADDRESS_OWN: 'WITHDRAWAL_ADDRESS_OWN',
    WITHDRAWAL_AMOUNT_INVALID: 'WITHDRAWAL_AMOUNT_INVALID',
    WITHDRAWAL_INSUFFICIENT_BALANCE: 'WITHDRAWAL_INSUFFICIENT_BALANCE',
    WITHDRAWAL_NOT_CONFIRMABLE: 'WITHDRAWAL_NOT_CONFIRMABLE',
    WITHDRAWAL_NOT_REVIEWABLE: 'WITHDRAWAL_NOT_REVIEWABLE',
    /** Never returned from a request; stored in `withdrawals.error_code` when Fluxson refuses the payout. */
    WITHDRAWAL_SUBMIT_FAILED: 'WITHDRAWAL_SUBMIT_FAILED',
    EXCHANGE_DISABLED: 'EXCHANGE_DISABLED',
    EXCHANGE_ASSET_NOT_SUPPORTED: 'EXCHANGE_ASSET_NOT_SUPPORTED',
    EXCHANGE_DIRECTION_UNAVAILABLE: 'EXCHANGE_DIRECTION_UNAVAILABLE',
    EXCHANGE_AMOUNT_OUT_OF_RANGE: 'EXCHANGE_AMOUNT_OUT_OF_RANGE',
    /** Carries `fields: string[]` with the exchanger's field ids (e.g. `toWallet`). */
    EXCHANGE_RECIPIENT_INVALID: 'EXCHANGE_RECIPIENT_INVALID',
    /** The order is not in a status that allows this action. */
    EXCHANGE_NOT_PAYABLE: 'EXCHANGE_NOT_PAYABLE',
    EXCHANGE_UPSTREAM_UNAVAILABLE: 'EXCHANGE_UPSTREAM_UNAVAILABLE',
    /** Never returned from a request; stored in `exchanges.error_code` when the exchanger closed or errored the order after payment. */
    EXCHANGE_FAILED_UPSTREAM: 'EXCHANGE_FAILED_UPSTREAM',
    /** Public API: the chain code is unknown or the chain is disabled. */
    CHAIN_NOT_SUPPORTED: 'CHAIN_NOT_SUPPORTED',
    /** Public API: the requested asset symbol is unknown on the chain, disabled in the catalogue or disabled for this user. */
    ASSET_NOT_SUPPORTED: 'ASSET_NOT_SUPPORTED',
    /** Fluxson answered with an error or timed out while CCex was serving a public API request. */
    WALLET_UPSTREAM_UNAVAILABLE: 'WALLET_UPSTREAM_UNAVAILABLE',
    /** Staff tried to revoke an API key that is already revoked. */
    API_KEY_REVOKED: 'API_KEY_REVOKED',
    /** Reply, assign or close on a closed ticket; reopen on a ticket that is not closed (spec 2026-10-28 §4). */
    SUPPORT_TICKET_NOT_OPEN: 'SUPPORT_TICKET_NOT_OPEN',
    /** Staff tried to create a ticket while the user already has a live one; carries `ticketId`. */
    SUPPORT_TICKET_LIVE_EXISTS: 'SUPPORT_TICKET_LIVE_EXISTS',
    /** The referenced operation does not exist or belongs to another user. */
    SUPPORT_REFERENCE_INVALID: 'SUPPORT_REFERENCE_INVALID',
    /** Telegram no longer serves the attachment's file. */
    SUPPORT_ATTACHMENT_UNAVAILABLE: 'SUPPORT_ATTACHMENT_UNAVAILABLE',
    BROADCAST_NOT_FOUND: 'BROADCAST_NOT_FOUND',
    /** `PATCH` on a broadcast that is no longer a draft (spec 2026-10-28 broadcasts §4.2). */
    BROADCAST_NOT_EDITABLE: 'BROADCAST_NOT_EDITABLE',
    /** Send on a non-draft, cancel on a non-sending, archive on a sending, test on an archived broadcast. */
    BROADCAST_INVALID_STATUS: 'BROADCAST_INVALID_STATUS',
    /** "Send to all" with nobody to send to. */
    BROADCAST_NO_RECIPIENTS: 'BROADCAST_NO_RECIPIENTS',
    /** The test user has no Telegram chat (a merged row). */
    BROADCAST_TEST_USER_UNREACHABLE: 'BROADCAST_TEST_USER_UNREACHABLE',
    /** Telegram rejected a test message; `detail` carries the Telegram answer, `extra.locale` which version, `extra.sent` which ones went out. */
    BROADCAST_TEST_FAILED: 'BROADCAST_TEST_FAILED',
};
//# sourceMappingURL=errors.js.map